import { DocumentField, Placeholder, SummaryCard } from '@if/mui'
import { CalendarSimulation } from '@src/types/loan/loan-simulation'
import { AlarmClock } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
  useLoanCalendarLastCompletedPaymentDate,
  useLoanCalendarNbDaysSinceLastCompletedPayment,
  useLoanCalendarNbOfCurrentLateDays,
} from '../LoanCalendar-hooks'

const EM_DASH = '—'

interface Props {
  simulation: CalendarSimulation
}

const LoanLateStatusCard = ({ simulation }: Props) => {
  const { t } = useTranslation()
  const currentLateDays = useLoanCalendarNbOfCurrentLateDays(simulation)
  const nbOfDaysBeforeLastCompletedPayment = useLoanCalendarNbDaysSinceLastCompletedPayment(simulation)
  const lastCompletedDate = useLoanCalendarLastCompletedPaymentDate(simulation)

  return (
    <SummaryCard icon={AlarmClock} title={t('loan.payment.lateStatusCard.title')} dense>
      <DocumentField
        label={t('loan.payment.lateStatusCard.daysLate')}
        align="right"
        value={t('common.days', { count: currentLateDays })}
        valueColor={currentLateDays > 0 ? 'error' : undefined}
        strong
      />
      <DocumentField
        label={t('loan.payment.lateStatusCard.daysSinceLatePayment')}
        align="right"
        value={nbOfDaysBeforeLastCompletedPayment ?? <Placeholder>{EM_DASH}</Placeholder>}
      />
      <DocumentField
        label={t('loan.payment.lateStatusCard.dateLastPayment')}
        align="right"
        value={lastCompletedDate?.toString() ?? <Placeholder>{EM_DASH}</Placeholder>}
      />
    </SummaryCard>
  )
}

export default LoanLateStatusCard
